import { gql } from '@apollo/client';

export const HAS_MY_REPORTING_REQUIREMENTS = gql`
  query hasMyReportingRequirements {
    hasRequirements: hasMyReportingRequirements
  }
`;
